import styled from "styled-components";
import { fadeIn, pulse } from "../../styles/Animations";

export const TabsContainer = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 2px solid #ccc;
  width: 90%;
`;

export const Tab = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  cursor: pointer;
  color: ${(props) => (props.active ? "#e30016" : "#666")};
  font-weight: ${(props) => (props.active ? "bold" : "normal")};
  border-bottom: ${(props) => (props.active ? "3px solid #e30016" : "none")};
  transition: all 0.3s ease-in-out;
  animation: ${fadeIn} 0.5s ease-in-out;

  &:hover {
    transform: translateY(-2px);
  }

  @media (max-width: 1100px) {
    /* Tablets */
    padding: 0px;
  }

  @media (max-width: 550px) {
    /* Phones */
    padding: 0px;
  }
`;

export const Icon = styled.div`
  font-size: 24px;
  margin-bottom: 5px;
  animation: ${pulse} 2s infinite ease-in-out;
`;

export const TabText = styled.div`
  font-size: 12px;
  text-transform: uppercase;

  @media (max-width: 1100px) {
    /* Tablets */
    font-size: 12px;
  }

  @media (max-width: 550px) {
    /* Phones */
    font-size: 12px;
  }
`;
